import { render, staticRenderFns } from "./addRewardTier.vue?vue&type=template&id=e4a85de2&"
import script from "./addRewardTier.vue?vue&type=script&lang=js&"
export * from "./addRewardTier.vue?vue&type=script&lang=js&"
import style0 from "./addRewardTier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a85de2')) {
      api.createRecord('e4a85de2', component.options)
    } else {
      api.reload('e4a85de2', component.options)
    }
    module.hot.accept("./addRewardTier.vue?vue&type=template&id=e4a85de2&", function () {
      api.rerender('e4a85de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/rewardController/component/addRewardTier.vue"
export default component.exports